const CS_SPOTLIGHT_ENDPOINT_BASE = "/jobteaser.cs_highlight.v1alpha1/CsHighlightService"
export const CS_SPOTLIGHT_GET_PAGE_ENDPOINT = `${CS_SPOTLIGHT_ENDPOINT_BASE}/GetCsHighlightPage`
export const CS_SPOTLIGHT_GET_PAGES_ENDPOINT = `${CS_SPOTLIGHT_ENDPOINT_BASE}/GetAllSchoolPages`
export const CS_SPOTLIGHT_SAVE_PAGE_ENDPOINT = `${CS_SPOTLIGHT_ENDPOINT_BASE}/SaveCsHighlightPage`
export const CS_SPOTLIGHT_PUBLISH_TOGGLE_ENDPOINT = `${CS_SPOTLIGHT_ENDPOINT_BASE}/ToggleCsHighlightPublished`
export const CS_SPOTLIGHT_UPLOAD_FILE_ENDPOINT = `${CS_SPOTLIGHT_ENDPOINT_BASE}/UploadFile`
